/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updating_CardInputs */



/**
* | output |
* | --- |
* | "Updating card..." |
*
* @param {Updating_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const updating_card = /** @type {((inputs?: Updating_CardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updating_CardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise à jour de la carte...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Karte wird aktualisiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento della scheda...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновление карты...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizando tarjeta...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在更新卡片...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カードを更新しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्ड अपडेट हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizando o cartão...")
	return /** @type {LocalizedString} */ ("Updating card...")
});